import dayjs from 'dayjs'

export const intentPermissions = { configView: 'intent:config:view', configEdit: 'intent:config:edit', orderView: 'intent:order:view', orderExport: 'intent:order:export', financeProcess: 'intent:finance:process', joinReview: 'intent:join:review' }
export const couponStates = [
  { value: 'NOT_ISSUED', label: '未发放' }, { value: 'AVAILABLE', label: '可抵扣' },
  { value: 'LOCKED', label: '已锁定' }, { value: 'REDEEMED', label: '已抵扣' },
  { value: 'EXPIRED', label: '已过期' }, { value: 'FINANCE_PROCESSED', label: '财务已处理（旧口径）' }
]
export const financeStates = [{ value: 'NONE', label: '无需处理' }, { value: 'PENDING', label: '待处理' }, { value: 'DONE', label: '已处理' }]
export const paymentStates = [{ value: 'WAIT_PAY', label: '待支付' }, { value: 'PAID', label: '支付成功' }]
// 意向金管理（原型146）的「当前状态」「用途」筛选与超期用途标记选项，取值与后台一致
export const intentStatusOptions = [{ value: 'WAIT_PAY', label: '待支付' }, { value: 'AVAILABLE', label: '可抵扣' }, { value: 'LOCKED', label: '已锁定' }, { value: 'REDEEMED', label: '已抵扣' }, { value: 'EXPIRED_PENDING', label: '已过期·待处理' }, { value: 'EXPIRED_MARKED', label: '已过期·已标记' }, { value: 'MARKETING_INCOME', label: '已转营销收入' }, { value: 'FINANCE_PROCESSED', label: '财务已处理（旧口径）' }]
export const intentUsageOptions = [{ value: 'JOIN', label: '加盟学费抵扣' }, { value: 'MEETING', label: '专题课会议抵扣' }, { value: 'MARKED', label: '超期用途标记' }, { value: 'MARKETING_INCOME', label: '到期转营销收入' }, { value: 'UNUSED', label: '未使用' }]
export const intentMarkOptions = [{ value: 'MEETING_LODGING', label: '专题课食宿相关' }, { value: 'JOIN_TUITION', label: '加盟学费相关' }, { value: 'OTHER', label: '其他' }]
export const applicationStates = [{ value: 'SUBMITTED', label: '已提交' }, { value: 'WAIT_PAYMENT', label: '待付款' }, { value: 'WAIT_REVIEW', label: '待审核' }, { value: 'RETURNED', label: '退回补资料' }, { value: 'COMPLETION_PENDING', label: '加盟开通中' }, { value: 'HOLD', label: '开通失败·待技术处理' }, { value: 'COMPLETED', label: '已完成' }, { value: 'REJECTED', label: '最终驳回' }, { value: 'WITHDRAWN', label: '已撤销' }]

// 购买链接只认完整 http(s) 地址，相对地址或带账号密码的地址不给复制
export function intentPurchaseUrl(value) {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value) || /\s/.test(value)) return ''
  try {
    const url = new URL(value)
    return url.username || url.password ? '' : url.href
  } catch (_) { return '' }
}

export function intentStateLabel(options, value) { const option = options.find(o => o.value === value); return option ? option.label : '状态未确认' }
export function intentAction(value, targetType) {
  if (value === 'CREATED') {
    if (targetType === 'CONFIG') return '新增售卖配置'
    if (targetType === 'ORDER') return '创建意向金订单'
    if (targetType === 'APPLICATION') return '创建加盟申请'
    return value
  }
  if (value === 'CASH_RECEIVED' && targetType === 'APPLICATION') return '加盟现金收款'
  if (value === 'UPGRADE_SUBMIT_FAILED') return '升级提交未成功'
  if (value === 'REVIEW_ATTEMPT_FAILED') return '审核未成功'
  return { UPDATED: '编辑售卖配置', ENABLED: '启用售卖配置', DISABLED: '停用售卖配置', CONFIG_CREATED: '新增售卖配置', CONFIG_UPDATED: '编辑售卖配置', CONFIG_ENABLED: '启用售卖配置', CONFIG_DISABLED: '停用售卖配置', LIVE_MOUNTED: '关联直播间', LIVE_REFRESHED: '刷新直播商品', LIVE_SORTED: '调整直播排序', LIVE_OFF: '下架直播商品', LIVE_ON: '上架直播商品', LIVE_CAN_BUY: '调整购买开关', LIVE_UNMOUNTED: '移除直播挂载', LIVE_RECOMMENDED: '调整直播推荐', LIVE_TIMED_OFF: '直播商品定时下架', PAID: '支付成功', CASH_RECEIVED: '意向金现金收款', LOCKED: '加盟申请锁定', RELEASED: '申请终止释放', REDEEMED: '加盟学费抵扣核销', JOIN_REDEEMED: '加盟学费抵扣核销', EXPIRED: '到期未使用·待标记用途', AUTO_MARKETING_INCOME: '到期自动转营销收入', MEETING_ATTENDED: '专题课期内参会·重算加盟截止', MARKETING_INCOME_MARKED: '财务转为营收', MEETING_DEDUCTED: '专题课会议抵扣', USAGE_MARKED: '超期用途标记', NOTE_SUPPLEMENT: '补充处理说明', NOTE_CORRECTION: '更正处理说明', PAYMENT_CLOSED: '加盟付款单已关闭', EXPIRED_MEETING_EXPENSE: '过期原款处理为会议费用', FINANCE_MEETING_EXPENSE: '过期原款处理为会议费用', FINANCE_PROCESSED: '财务处理完成', RETURNED_FOR_SUPPLEMENT: '退回补资料（保持锁定）', PAYMENT_RECEIVED: '支付成功', SUBMITTED: '提交加盟申请', RESUBMITTED: '补充资料后重新提交', INITIAL_APPROVED: '初审通过', COMPLETED: '加盟完成', COMPLETION_HOLD: '加盟开通失败，待技术处理', RETRY_COMPLETION: '重新开通加盟', WITHDRAWN: '撤销加盟申请', JOIN_CASH_RECEIVED: '加盟现金收款', JOIN_OFFLINE_CASH_RECEIVED: '加盟线下收款', REGISTRATION_LINKED: '关联报名记录', FINANCE_TUITION_ASSOCIATED: '关联学费报名', FINANCE_EXPERIENCE_TUITION: '处理为体验课学费', FINANCE_ADVANCED_TUITION: '处理为进阶课学费', FINANCE_RECEIVED_FUNDS: '财务确认收款', FINANCE_ATTEMPT_FAILED: '财务处理未成功' }[value] || value || '-'
}

// 当前账号的菜单里有没有这个页面（res_code），没有就不给跳转链接
export function canOpenMenu(store, path) {
  const permissions = store && store.getters && store.getters.permissions
  if (Array.isArray(permissions) && permissions.includes('*:*:*')) return true
  const walk = list => Array.isArray(list) && list.some(r => r && (r.path === path || walk(r.children)))
  return walk(store && store.state && store.state.user && store.state.user.routes)
}

export function hasIntentPermission(store, permission) {
  const permissions = store && store.getters && store.getters.permissions
  return Array.isArray(permissions) && (permissions.includes('*:*:*') || permissions.includes(permission))
}

export function intentRows(data) {
  const rows = Array.isArray(data) ? data : data && data.records
  if (!Array.isArray(rows) || rows.some(row => !row || typeof row !== 'object' || Array.isArray(row))) throw new Error('意向金列表返回格式异常，请重新加载')
  return rows
}

export function intentTime(value) {
  if (!value) return '-'
  const date = dayjs(value)
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : '-'
}

export function intentMoney(value) {
  if (value === null || value === undefined || value === '') return '-'
  const amount = Number(value)
  return Number.isFinite(amount) ? amount.toFixed(2) : '-'
}

export function validIntentAmount(value) {
  return /^\d+(\.\d{1,2})?$/.test(String(value)) && Number(value) > 0
}

export function uploadedIntentUrl(value) {
  return typeof value === 'string' && /^https:\/\/[^\s]+$/i.test(value)
}

export function intentPage(query, dates = []) {
  return { ...query, paidFrom: dates[0] || undefined, paidTo: dates[1] || undefined }
}
